// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientsContainer {
  width: 100%;
  background-color: #f5f4fb;
  padding: 70px 24px 80px;
}

.clientsHeading {
  font-weight: 800;
  color: #172639;
  font-size: 2.5rem;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.clientsSubheading {
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 40px;
}

.clientsCards {
  max-width: 1200px;
  margin: 0 auto;
}

.clientCard {
  background-color: #ffffff;
  border: 1px solid #ececec;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  padding: 28px 18px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.clientCard:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(23, 38, 57, 0.12);
  border-color: #eaa637;
}

.clientLogoBox {
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clientLogoImg {
  max-width: 100%;
  max-height: 72px;
  object-fit: contain;
}

.clientLogoImg.clientLogoImgLarge {
  max-height: 108px;
}

@media (max-width: 768px) {
  .clientsContainer {
    padding: 50px 16px 60px;
  }

  .clientsHeading {
    font-size: 1.9rem;
  }

  .clientsSubheading {
    font-size: 0.9rem;
  }

  .clientLogoBox {
    height: 56px;
  }

  .clientLogoImg.clientLogoImgLarge {
    max-height: 84px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OurClients.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".clientsContainer {\n  width: 100%;\n  background-color: #f5f4fb;\n  padding: 70px 24px 80px;\n}\n\n.clientsHeading {\n  font-weight: 800;\n  color: #172639;\n  font-size: 2.5rem;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.clientsSubheading {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-bottom: 40px;\n}\n\n.clientsCards {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.clientCard {\n  background-color: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);\n  padding: 28px 18px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.clientCard:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 28px rgba(23, 38, 57, 0.12);\n  border-color: #eaa637;\n}\n\n.clientLogoBox {\n  width: 100%;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.clientLogoImg {\n  max-width: 100%;\n  max-height: 72px;\n  object-fit: contain;\n}\n\n.clientLogoImg.clientLogoImgLarge {\n  max-height: 108px;\n}\n\n@media (max-width: 768px) {\n  .clientsContainer {\n    padding: 50px 16px 60px;\n  }\n\n  .clientsHeading {\n    font-size: 1.9rem;\n  }\n\n  .clientsSubheading {\n    font-size: 0.9rem;\n  }\n\n  .clientLogoBox {\n    height: 56px;\n  }\n\n  .clientLogoImg.clientLogoImgLarge {\n    max-height: 84px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
